import React from "react";
import { Box, Tabs, Tab } from "@mui/material";
import { TabPanel, TabContext } from "@mui/lab";
import SyncIcon from "@mui/icons-material/Sync";
import request from "../../../utilities/requests";

import AllEvents from "./AllEvents";
import PairingEvents from "./PairingEvents";

import { EventContext } from "../../../contexts/EventContext";
import { toast } from "../../../utilities/SnackBarUtils";

const EventTabs = ({ user }) => {
  const { userData } = React.useContext(EventContext);
  const [value, setValue] = React.useState("2");
  const [canViewEvents, setCanViewEvents] = React.useState(false);

  React.useEffect(() => {
    if (userData?.org?.defaultPairing === false) {
      setCanViewEvents(true)
    }
  },[userData])



  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleSync = async () => {
    let result = await request("events/sync", "post");
    if (!result.success) {
      alert(result.error);
    } else {
      toast.success("Events synced with Eventbrite!");
    }
  };

  return (
    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
      <TabContext value={value}>
        <Tabs value={value} onChange={handleChange}>
          {/* Conditional rendering of tabs */}
          {[
            canViewEvents && <Tab key="1" label="All Events" value="1" />,
            <Tab key="2" label="Pairing Events" value="2" />
          ]}
        </Tabs>
        <TabPanel value="1">
          <AllEvents user={user} />
        </TabPanel>
        <TabPanel value="2">
          <PairingEvents user={user} />
        </TabPanel>
      </TabContext>
      <SyncIcon
        onClick={handleSync}
        style={{ position: "fixed", top: 75, right: 30, cursor: "pointer" }}
      />
    </Box>
  );
};

export default EventTabs;
